function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200.93,
    height: 76.32,
    viewBox: "0 0 200.93 76.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g884"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M457.23,836.6a2.22,2.22,0,0,1,2.49-2.37,3.85,3.85,0,0,1,1.82.42v-5.29a6.78,6.78,0,0,0-2.92-.59c-4.68,0-7.43,2.9-7.43,7.69v.46H449v5.14h2.23v12.35h6V842.06h4.08v-5.14h-4.08Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M469.81,854.41V836.92h-6.08v17.49Zm.36-22.42a3.4,3.4,0,1,0-3.41,3.53A3.49,3.49,0,0,0,470.17,832Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M478.36,845.11c0-1.82.87-2.84,2.19-2.84s2.13,1,2.13,2.77v9.37h6.07V843.29c0-4.24-2.19-6.86-5.77-6.86a5,5,0,0,0-4.62,2.62v-2.13h-6.07v17.49h6.07Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M498.69,836.57c-5,0-8.24,4.58-8.24,9.16,0,5.11,3.53,9.17,8.17,9.17a5.54,5.54,0,0,0,4.78-2.13v1.68h5.85V837H503.4v1.57a6,6,0,0,0-4.71-2Zm1.25,5.63a3.44,3.44,0,0,1,3.53,3.53,3.49,3.49,0,0,1-3.53,3.61,3.59,3.59,0,0,1-3.54-3.54,3.43,3.43,0,0,1,3.54-3.6Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M518.2,845.11c0-1.82.86-2.84,2.19-2.84s2.12,1,2.12,2.77v9.37h6.08V843.29c0-4.24-2.19-6.86-5.78-6.86a5,5,0,0,0-4.61,2.62v-2.13h-6.08v17.49h6.08Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    d: "M530.38,845.66c0,5.67,3.85,9.24,8.87,9.24a8.39,8.39,0,0,0,4-1v-5.81a4.91,4.91,0,0,1-3,1,3.5,3.5,0,1,1,0-7,5.15,5.15,0,0,1,3,1v-5.81a8.74,8.74,0,0,0-3.88-.91C534.13,836.43,530.38,840.31,530.38,845.66Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M556.45,848.25a2.83,2.83,0,0,1-2.76,1.54,2.88,2.88,0,0,1-3.05-2.52h11.48a12.53,12.53,0,0,0,.07-1.29c0-5.77-3.49-9.55-8.67-9.55-5,0-8.83,4-8.83,9.23,0,5.5,3.72,9.24,9,9.24,3.75,0,6.58-1.68,7.94-4.72Zm-5.78-4.65a2.65,2.65,0,0,1,2.82-2.27,2.6,2.6,0,0,1,2.82,2.27Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1139",
    d: "M375.56,792.27h11.95l7,18,7-18h11.64L395.63,834.8H383.92l4.8-11.27Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1141",
    d: "M425.28,791.55c-9,0-14.65,8.13-14.65,16.22,0,9.11,6.22,16.33,14.48,16.33,6.17,0,8.49-3.79,8.49-3.79v3H444v-31H433.6v2.81S431,791.55,425.28,791.55Zm2.22,10a6.34,6.34,0,0,1,0,12.67,6.34,6.34,0,0,1-6.3-6.24A6.12,6.12,0,0,1,427.5,801.51Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1145",
    d: "M447.62,823.26V778.58h10.9v16.61a10.08,10.08,0,0,1,8-3.63c6.64,0,10.52,5,10.52,12.11v19.59H466.24v-16.9c0-2.42-1.14-4.75-3.72-4.75s-4,2.37-4,4.75v16.9Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1147",
    d: "M495.66,791.56c-10.29,0-16.41,7.89-16.41,16.34,0,9.62,7.41,16.2,16.44,16.2,8.76,0,16.42-6.28,16.42-16C512.11,797.38,504.09,791.56,495.66,791.56Zm.09,10a6.22,6.22,0,0,1,6.15,6.31,6.31,6.31,0,0,1-6.15,6.2,6.11,6.11,0,0,1-6.1-6.23A6,6,0,0,1,495.75,801.6Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    d: "M530.28,791.56c-10.29,0-16.41,7.89-16.41,16.34,0,9.62,7.41,16.2,16.45,16.2,8.75,0,16.41-6.28,16.41-16C546.73,797.38,538.71,791.56,530.28,791.56Zm.1,10a6.22,6.22,0,0,1,6.14,6.31,6.31,6.31,0,0,1-6.14,6.2,6.12,6.12,0,0,1-6.11-6.23A6,6,0,0,1,530.38,801.6Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "path1155",
    cx: 179.78,
    cy: 38.03,
    rx: 7.24,
    ry: 7.31,
    style: {
      fill: "#35393a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1157",
    d: "M565,806.62h-13l11.57-28h13Z",
    transform: "translate(-375.56 -778.58)",
    style: {
      fill: "#35393a"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/YAHOO.fd828a3af23b9d6484d287f73b199613.svg";
export { ForwardRef as ReactComponent };